import { render, staticRenderFns } from "./MXStatusTabs.vue?vue&type=template&id=7a015534&scoped=true"
import script from "./MXStatusTabs.vue?vue&type=script&lang=js"
export * from "./MXStatusTabs.vue?vue&type=script&lang=js"
import "./MXStatusTabs.vue?vue&type=style&index=0&id=7a015534&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a015534",
  null
  
)

export default component.exports